module.exports = __webpack_public_path__ + "static/media/STRAX.7c8763b5.svg";